/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { FunctionComponent, useEffect } from 'react';

import { BrandingUiInfoKeys } from '../../../core/entities';
import { ServicesClientImpl } from '../../../core/interactors';
import { Locale, LocaleKeys } from '../../../core/locale';
import {
    KeyManager,
    LocationUrls,
    ScreenControllerTypes,
    ScreenTaskControllerTypes,
} from '../../../core/navigation';
import { TScreen } from '../../../core/navigation/types';
import { BrandingUiUtility } from '../../../core/utils';
import { useScreenController } from '../../hooks';
import { SettingsTemplate } from '../SettingsTemplate';

import '../SettingsCommon.scss';
import './CloudDVRHelp.scss';

const defaultServices = new ServicesClientImpl();

const TAG = 'CloudDVRHelp';

const CloudDVRHelp: FunctionComponent = () => {
    useScreenController<TScreen>({
        identifier: TAG,
        properties: {
            url: LocationUrls.CLOUD_DVR_HELP_SCREEN,
            screenController: ScreenControllerTypes.CLOUD_DVR_HELP_SCREEN,
            taskController: ScreenTaskControllerTypes.NO_TASK,
        },
    });

    const rawText = Locale.getString(LocaleKeys.SETTINGS_HELP_DVR_SERVICE);
    const text = BrandingUiUtility.formatDescription(rawText, {
        CUSTOMER_SUPPORT_NAME: defaultServices.getBrandingUiInfoForKey(
            BrandingUiInfoKeys.CUSTOMER_SUPPORT_NAME,
        ),
        PHONE_CUSTOMER_SUPPORT_NUMBER: defaultServices.getBrandingUiInfoForKey(
            BrandingUiInfoKeys.PHONE_CUSTOMER_SUPPORT_NUMBER,
        ),
        DEVICE_NAME: defaultServices.getBrandingUiInfoForKey(BrandingUiInfoKeys.DEVICE_NAME),
    });

    useEffect(() => {
        const keyManagerIns: KeyManager = KeyManager.getInstance();
        if (keyManagerIns.isKeyIgnoring()) {
            keyManagerIns.stopKeyIgnoring();
        }
    }, []);

    return (
        <SettingsTemplate title={Locale.getString(LocaleKeys.CLOUD_DVR_SERVICE_TITLE)}>
            <div className="settings-common-content text-content">{text}</div>
        </SettingsTemplate>
    );
};

export default CloudDVRHelp;
